import { render, staticRenderFns } from "./MyDraftLandownerReports.vue?vue&type=template&id=f2e8ea6a"
import script from "./MyDraftLandownerReports.vue?vue&type=script&lang=js"
export * from "./MyDraftLandownerReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports